"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDealSummaryFromOffer = exports.overrideDealSummaryValues = exports.mapOfferValues = exports.formatDealSummary = void 0;
var selectn_1 = __importDefault(require("selectn"));
var dr_common_utils_1 = require("@makemydeal/dr-common-utils");
var labelTypes_1 = require("./labels/labelTypes");
var dealSummaryLabels_1 = require("./labels/labelSets/dealSummaryLabels");
var lodash_1 = require("lodash");
var dealSummaryTypes_1 = require("./types/dealSummaryTypes");
// TODO: Evaluate how we deal with bold/negative formatting
var isNegativeValue = function (properties) {
    return properties && properties.indexOf(dealSummaryTypes_1.DisplayProperties.UNNATURAL) !== -1;
};
var isBold = function (properties) {
    return properties && properties.indexOf(dealSummaryTypes_1.DisplayProperties.IMPORTANT) !== -1;
};
// TODO: Evaluate whether formatting logic can be done without introducing types
var formatDealSummary = function (sourceDealSummary) {
    if (sourceDealSummary === void 0) { sourceDealSummary = []; }
    var targetDealSummary = sourceDealSummary.map(function (element) {
        var val = {
            Description: element.description,
            Attributes: {},
            Value: null
        };
        switch (element.type) {
            case dealSummaryTypes_1.DataType.APR:
                val.Value = dr_common_utils_1.formatUtils.formatAPR(element.value);
                break;
            case dealSummaryTypes_1.DataType.MONEY:
                if (isNegativeValue(element.displayProperties)) {
                    val.Value = "- ".concat(dr_common_utils_1.formatUtils.formatDollars(element.value));
                }
                else {
                    val.Value = dr_common_utils_1.formatUtils.formatDollars(element.value);
                }
                break;
            case dealSummaryTypes_1.DataType.MILES:
                val.Value = dr_common_utils_1.formatUtils.formatMiles(element.value);
                break;
            case dealSummaryTypes_1.DataType.SEPARATOR:
                val.Value = '';
                val.Attributes.Separator = true;
                break;
            default:
                val.Value = element.value;
        }
        if (isBold(element.displayProperties)) {
            val.Attributes.Bold = true;
        }
        return val;
    });
    return targetDealSummary;
};
exports.formatDealSummary = formatDealSummary;
function createLineItem(key, description, value, type, displayPropertiesOrig, items) {
    if (type === void 0) { type = dealSummaryTypes_1.DataType.STRING; }
    if (displayPropertiesOrig === void 0) { displayPropertiesOrig = []; }
    if (items === void 0) { items = []; }
    var displayProperties = displayPropertiesOrig;
    if (value === 0) {
        // Don't want to display negative styling for values equal to 0
        displayProperties = displayPropertiesOrig.filter(function (item) { return item !== dealSummaryTypes_1.DisplayProperties.UNNATURAL; });
    }
    return {
        description: description,
        displayProperties: displayProperties,
        items: items,
        key: key,
        type: type,
        value: value
    };
}
function createDealerFees(dealerFeeList) {
    var dealerFees = {
        capped: [],
        noncapped: []
    };
    if (!dealerFeeList) {
        return dealerFees;
    }
    var count = 0;
    dealerFeeList.forEach(function (dealerFee) {
        count += 1;
        var newFee = createLineItem("dealerFee".concat(count), dealerFee.dealerFeeName, dealerFee.dealerFeeAmount, dealSummaryTypes_1.DataType.MONEY);
        newFee.isFeeCapped = dealerFee.dealerFeeCapped;
        if (dealerFee.dealerFeeCapped) {
            dealerFees.capped.push(newFee);
        }
        else {
            dealerFees.noncapped.push(newFee);
        }
    });
    return dealerFees;
}
function createTradeAllowance(tradeAllowance, financeNegativeTradeEquity) {
    var tradeAllowanceResult = createLineItem(labelTypes_1.DealSummaryLabelType.TRADE_ALLOWANCE, dealSummaryLabels_1.DealSummaryLabels.TRADE_ALLOWANCE, tradeAllowance, dealSummaryTypes_1.DataType.MONEY);
    if (financeNegativeTradeEquity && tradeAllowanceResult.value < 0) {
        tradeAllowanceResult.value = Math.abs(tradeAllowanceResult.value);
    }
    else if (tradeAllowance > 0) {
        tradeAllowanceResult.displayProperties.push(dealSummaryTypes_1.DisplayProperties.UNNATURAL);
    }
    return tradeAllowanceResult;
}
function createOtherFees(monthlyPayment, offerType, financeNegativeTradeEquity, netTrade) {
    var fees = {
        capped: [],
        noncapped: []
    };
    if (!financeNegativeTradeEquity && netTrade < 0) {
        var trade = createLineItem(labelTypes_1.DealSummaryLabelType.TRADE_ALLOWANCE, dealSummaryLabels_1.DealSummaryLabels.TRADE_ALLOWANCE, Math.abs(netTrade), dealSummaryTypes_1.DataType.MONEY);
        trade.isFeeCapped = false;
        fees.noncapped.push(trade);
    }
    if (offerType === dealSummaryTypes_1.DealSummaryOfferTypeEnum.LEASE) {
        var firstPayment = createLineItem(labelTypes_1.DealSummaryLabelType.FIRST_MONTH_PAYMENT, dealSummaryLabels_1.DealSummaryLabels.FIRST_MONTH_PAYMENT, Math.ceil(monthlyPayment), dealSummaryTypes_1.DataType.MONEY);
        firstPayment.isFeeCapped = false;
        fees.noncapped.push(firstPayment);
    }
    return fees;
}
var separator = createLineItem(labelTypes_1.DealSummaryLabelType.SEPARATOR, dealSummaryLabels_1.DealSummaryLabels.SEPARATOR, '', dealSummaryTypes_1.DataType.SEPARATOR, [
    dealSummaryTypes_1.DisplayProperties.SEPARATOR
]);
// TODO: Read the net trade in value from the offer payload
function getNetTradeIn(offer) {
    if (offer.isTradeCompleted && !offer.isTradeSkipped) {
        var tradeValue = (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.TRADE_VALUE, offer) || 0;
        var tradeOwed = (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.TRADE_OWED, offer) || 0;
        return tradeValue - tradeOwed;
    }
    return 0;
}
function isVehicleNew(offer) {
    var offerCondition = (0, selectn_1.default)('vehicle.condition', offer);
    if (offerCondition) {
        return offerCondition.toUpperCase() === 'NEW';
    }
    return false;
}
/**
 * TODO: The values here should not need the `offer` prefix, refactor variable names in createDealSummaryFromOffer
 * to fix this
 */
var mapOfferValues = function (offer) {
    var offerType = offer.type;
    var mappedValues = {
        isVehicleNew: isVehicleNew(offer),
        isSinglePrice: offer.isSinglePrice,
        offerType: offerType,
        retailPrice: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.RETAIL_PRICE, offer),
        annualMiles: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.ANNUAL_MILES, offer),
        offerDownPayment: offer.downPayment,
        offerDealerFees: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.DEALER_FEES, offer),
        offerAmountFinanced: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.AMT_FINANCED, offer),
        offerApr: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.APR, offer),
        offerTerm: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.TERM, offer),
        appliedIncentiveAmount: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.INCENTIVES, offer) || 0,
        financeNegativeTradeEquity: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.TRADE_APPLIED_FINANCE, offer) || false,
        netTradeIn: getNetTradeIn(offer),
        deductDueAtSigning: (offerType === dealSummaryTypes_1.DealSummaryOfferTypeEnum.LEASE && offer.deductDueAtSigning) || false,
        offerDMVFeesTotal: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.DMV_FEES, offer) || 0,
        offerTaxes: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.TAXES, offer) || 0,
        monthlyPayment: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.MOMTHLY_PMT, offer),
        adjustedTradeInValue: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.TRADE_ADJ, offer),
        offerPrice: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.OFFER_PRICE, offer),
        taxesCapped: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.TAXES_CAPPED, offer),
        taxesUpFront: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.TAXES_UP_FRONT, offer),
        totalTax: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.TOTAL_TAX, offer),
        securityDeposit: (0, selectn_1.default)(dealSummaryTypes_1.OfferPaths.SECURITY_DEPOSIT, offer)
    };
    mappedValues = (0, lodash_1.merge)((0, exports.overrideDealSummaryValues)(offer), mappedValues);
    return mappedValues;
};
exports.mapOfferValues = mapOfferValues;
var overrideDealSummaryValues = function (offer) {
    var overrides = {};
    var counterOfferOverride = offer.counterOfferOverride;
    if (counterOfferOverride) {
        overrides.annualMiles = counterOfferOverride.annualMiles || 0;
        overrides.offerAmountFinanced = counterOfferOverride.totalFinanced;
        overrides.offerApr = counterOfferOverride.apr;
        overrides.offerTerm = counterOfferOverride.financeTerm;
        overrides.offerPrice = counterOfferOverride.sellingPrice;
        overrides.netTradeIn = counterOfferOverride.netTradeInEquity;
        overrides.monthlyPayment = counterOfferOverride.monthlyPayment;
        overrides.offerDownPayment = counterOfferOverride.totalDueAtSigning || counterOfferOverride.totalCashDown;
        overrides.downPaymentNegative = counterOfferOverride.totalCashDown;
    }
    return overrides;
};
exports.overrideDealSummaryValues = overrideDealSummaryValues;
/*
 * Converts a list of menu summary elements to a deal summary line item
 * @param menuSummary MenuSummaryProduct[]
 * @returns DealSummaryLineItem[]
 */
var convertMenuToLineItems = function (menuSummary) {
    var lineItems = menuSummary.map(function (_a, index) {
        var product = _a.product, price = _a.price;
        return createLineItem("menuItem".concat(index), product, price, dealSummaryTypes_1.DataType.STRING);
    });
    return lineItems;
};
var createDealSummaryFromOffer = function (offer, extraDealSummaryData) {
    if (extraDealSummaryData === void 0) { extraDealSummaryData = {}; }
    var _a = (0, exports.mapOfferValues)(offer), isVehicleNew = _a.isVehicleNew, offerType = _a.offerType, isSinglePrice = _a.isSinglePrice, offerPrice = _a.offerPrice, retailPrice = _a.retailPrice, annualMiles = _a.annualMiles, offerDealerFees = _a.offerDealerFees, offerAmountFinanced = _a.offerAmountFinanced, offerApr = _a.offerApr, offerTerm = _a.offerTerm, appliedIncentiveAmount = _a.appliedIncentiveAmount, offerDownPayment = _a.offerDownPayment, financeNegativeTradeEquity = _a.financeNegativeTradeEquity, netTradeIn = _a.netTradeIn, deductDueAtSigning = _a.deductDueAtSigning, offerDMVFeesTotal = _a.offerDMVFeesTotal, offerTaxes = _a.offerTaxes, monthlyPayment = _a.monthlyPayment, securityDeposit = _a.securityDeposit, 
    // TODO: Work with product to fix the logic of displaying trade line items in two different spots
    adjustedTradeInValue = _a.adjustedTradeInValue;
    var amountFinancedLabel = offerType === dealSummaryTypes_1.DealSummaryOfferTypeEnum.FINANCE
        ? dealSummaryLabels_1.DealSummaryLabels.AMT_FINANCED_FINANCE
        : dealSummaryLabels_1.DealSummaryLabels.AMT_FINANCED_LEASE;
    var msrpLabel = !isSinglePrice && !isVehicleNew ? dealSummaryLabels_1.DealSummaryLabels.ADVERTISED_PRICE : dealSummaryLabels_1.DealSummaryLabels.MSRP;
    var msrp = createLineItem(labelTypes_1.DealSummaryLabelType.MSRP, msrpLabel, retailPrice, dealSummaryTypes_1.DataType.MONEY);
    var amountFinanced = createLineItem(labelTypes_1.DealSummaryLabelType.AMT_FINANCED, amountFinancedLabel, Math.ceil(offerAmountFinanced), dealSummaryTypes_1.DataType.MONEY, [dealSummaryTypes_1.DisplayProperties.IMPORTANT]);
    var annualMilesResult = createLineItem(labelTypes_1.DealSummaryLabelType.ANNUAL_MILES, dealSummaryLabels_1.DealSummaryLabels.ANNUAL_MILES, annualMiles, dealSummaryTypes_1.DataType.MILES);
    var apr = createLineItem(labelTypes_1.DealSummaryLabelType.APR, dealSummaryLabels_1.DealSummaryLabels.APR, offerApr, dealSummaryTypes_1.DataType.APR, [
        dealSummaryTypes_1.DisplayProperties.IMPORTANT
    ]);
    var dealerFees = createDealerFees(offerDealerFees);
    var dmvFees = createLineItem(labelTypes_1.DealSummaryLabelType.DMV_FEES, dealSummaryLabels_1.DealSummaryLabels.DMV_FEES, offerDMVFeesTotal, dealSummaryTypes_1.DataType.MONEY);
    var incentivesAmount = createLineItem(labelTypes_1.DealSummaryLabelType.INCENTIVES, dealSummaryLabels_1.DealSummaryLabels.INCENTIVES, appliedIncentiveAmount, dealSummaryTypes_1.DataType.MONEY, [dealSummaryTypes_1.DisplayProperties.UNNATURAL]);
    var otherFees = createOtherFees(monthlyPayment, offerType, financeNegativeTradeEquity, netTradeIn);
    var securityDepositLineItem = createLineItem(labelTypes_1.DealSummaryLabelType.SECURITY_DEPOSIT, dealSummaryLabels_1.DealSummaryLabels.SECURITY_DEPOSIT, securityDeposit, dealSummaryTypes_1.DataType.MONEY);
    var taxes = createLineItem(labelTypes_1.DealSummaryLabelType.TAXES, dealSummaryLabels_1.DealSummaryLabels.TAXES, Math.ceil(offerTaxes), dealSummaryTypes_1.DataType.MONEY);
    var term = createLineItem(labelTypes_1.DealSummaryLabelType.TERM, dealSummaryLabels_1.DealSummaryLabels.TERM, offerTerm, dealSummaryTypes_1.DataType.MONTHS, [
        dealSummaryTypes_1.DisplayProperties.IMPORTANT
    ]);
    var tradeAllowance = createTradeAllowance(netTradeIn, financeNegativeTradeEquity);
    var priceLabel = isSinglePrice ? dealSummaryLabels_1.DealSummaryLabels.PRICE_SINGLE : dealSummaryLabels_1.DealSummaryLabels.PRICE_MULTI;
    var yourPrice = createLineItem(labelTypes_1.DealSummaryLabelType.PRICE, priceLabel, offerPrice, dealSummaryTypes_1.DataType.MONEY);
    var downPaymentDescription = offerType === dealSummaryTypes_1.DealSummaryOfferTypeEnum.FINANCE
        ? dealSummaryLabels_1.DealSummaryLabels.DOWN_PAYMENT_FINANCE
        : dealSummaryLabels_1.DealSummaryLabels.DOWN_PAYMENT_LEASE;
    var downPaymentResult = createLineItem(labelTypes_1.DealSummaryLabelType.DOWN_PAYMENT, downPaymentDescription, (0, selectn_1.default)('payment.netCashDown', offer), dealSummaryTypes_1.DataType.MONEY);
    var customerDownPayment = createLineItem(labelTypes_1.DealSummaryLabelType.DOWN_PAYMENT_NEGATIVE, downPaymentDescription, (0, selectn_1.default)('payment.netCashDown', offer), dealSummaryTypes_1.DataType.MONEY);
    var dueAtSigningResult = createLineItem(labelTypes_1.DealSummaryLabelType.DUE_AT_SIGNING, dealSummaryLabels_1.DealSummaryLabels.DUE_AT_SIGNING, (0, selectn_1.default)('payment.dueAtSigning', offer), dealSummaryTypes_1.DataType.MONEY, [dealSummaryTypes_1.DisplayProperties.IMPORTANT]);
    var dealSummary = isSinglePrice && !isVehicleNew ? [yourPrice] : [msrp, separator, yourPrice];
    if (isVehicleNew && incentivesAmount.value > 0) {
        dealSummary.push(incentivesAmount);
    }
    dealSummary.push(customerDownPayment);
    if (netTradeIn > 0 || financeNegativeTradeEquity) {
        dealSummary.push(tradeAllowance);
    }
    if (Array.isArray(extraDealSummaryData.menu) && extraDealSummaryData.menu.length > 0) {
        var menuLineItems = convertMenuToLineItems(extraDealSummaryData.menu);
        dealSummary = __spreadArray(__spreadArray([], dealSummary, true), menuLineItems, true);
    }
    // If taxes & DMV Fees are 0, don't show them as line items
    if (taxes.value > 0) {
        dealSummary.push(taxes);
    }
    if (dmvFees.value > 0) {
        dealSummary.push(dmvFees);
    }
    dealSummary = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], dealSummary, true), dealerFees.capped, true), otherFees.capped, true), [
        separator,
        amountFinanced,
        separator,
        downPaymentResult
    ], false);
    if (securityDepositLineItem.value > 0) {
        dealSummary.push(securityDepositLineItem);
    }
    if (!financeNegativeTradeEquity && adjustedTradeInValue > 0) {
        dealSummary.push(tradeAllowance);
    }
    dealSummary = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], dealSummary, true), dealerFees.noncapped, true), otherFees.noncapped, true), [separator, dueAtSigningResult, separator, term], false);
    if (offerType === dealSummaryTypes_1.DealSummaryOfferTypeEnum.FINANCE) {
        dealSummary.push(apr);
    }
    else {
        dealSummary.push(annualMilesResult);
    }
    return dealSummary;
};
exports.createDealSummaryFromOffer = createDealSummaryFromOffer;
